import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { isStringArray } from '@platform/shared/utilities/obserables-utils';
import { OptionItem, provideParentFormGroup } from '../forms.utils';
import { FormBaseComponent } from '../form-base/form-base.component';
import { PreComponent } from '../../pre/pre.component';

@Component({
  selector: 'app-form-select',
  standalone: true,
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatSelectModule],
})
export class FormSelectComponent extends FormBaseComponent {
  @Input({ required: true }) items: Array<OptionItem> | string[] = [];
  @Input() includeEmptyOption = false;

  get itemsInternal(): OptionItem[] {
    if (!this.items.length) {
      return [];
    }

    if (isStringArray(this.items)) {
      return this.items.map((item) => ({ label: item, value: item }));
    } else {
      return this.items;
    }
  }

  trackByOption(index: number, item: any) {
    if (item.value === 'undefined') {
      return index;
    }
    return item.value;
  }
}
